const _require = require('@truqc/content-path'),
  appendPath = _require.appendPath;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate performBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const contentPath = await evaluateSource(source.contentPath, content, parentContentPath, transientContext, nativeFunctions);
  const newParentContentPath = appendPath(parentContentPath, contentPath);
  return evaluateSource(source.actions, content, newParentContentPath, transientContext, nativeFunctions);
};
module.exports = {
  evaluate
};